import React from "react";
import PropTypes from "prop-types";
import IconBase from "./IconBase";

function SpotlightLightIcon(props) {
  return <IconBase {...props} />;
}

SpotlightLightIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeColor: PropTypes.string,
  pathColor: PropTypes.string,
};

export default SpotlightLightIcon;
